import React from 'react';
import Button from '../../../../muiComponents/Button';
import useTranslate from '../../../../customHooks/useTranslate';
import { useNotification } from '../../../../contexts/NotificationsContext';
import { rejectConnectionToMember } from '../../../../services/zinantis/members/zinantisMemberListServices';
import { IZinantisConnectionRequest } from '../../../../types/entities/IZinantisConnectionRequest';
import { FeedbackMessages } from '../../../../utils/commonVariables/messages';

interface IRejectConnectionButtonProps {
    onChangeLoading: (isLoading: boolean) => void;
    onRequestSuccess: (newRequest: IZinantisConnectionRequest) => Promise<void>;
    idRequest: number | string;
}

const RejectConnectionButton = (props: IRejectConnectionButtonProps) => {
    const { onChangeLoading, onRequestSuccess, idRequest } = props;
    const { setErrorMessage, setSuccessMessage } = useNotification();

    const translate = useTranslate();

    const handleRejectConnection = async () => {
        try {
            onChangeLoading(true);
            const { data } = await rejectConnectionToMember(idRequest);
            if (data.Success && data.StatusCode === 200) {
                await onRequestSuccess(data.Result);
                setSuccessMessage(
                    FeedbackMessages.SUCCESSFUL_CONNECTION_REQUEST_REJECTED
                );
            } else {
                setErrorMessage(FeedbackMessages.ERROR_FETCHING);
            }
        } catch (error) {
            console.log({ error });
            setErrorMessage(FeedbackMessages.ERROR_FETCHING);
        } finally {
            onChangeLoading(false);
        }
    };

    return (
        <Button
            startIcon='LinkOff'
            variant='contained'
            className='delete-button white-space-nowrap'
            style={{ height: '30px' }}
            onClick={handleRejectConnection}
        >
            {translate('reject')}
        </Button>
    );
};

export default RejectConnectionButton;
